import { Box, Grid, TextField, Typography, Autocomplete } from "@mui/material";
import axios from "axios";
import { useEffect, useRef, useState } from "react";
import { api_base } from "../../env";
import { useNavigate, useParams } from "react-router";
import BackLoading from "../../composant/loading/backLoading";
import { useDispatch, useSelector } from "react-redux";
import { VidePanier } from "../../store/slice/gestionImageSlice";
import { ImportButton } from "../../composant/UploadFiles";
import { StorageDataClient } from "../../store/slice/InfoClientSlice";
import DrawerAppBar from "../../composant/navbar/Navbar";
import SuccessWithRouletteDialog from "../../composant/Popup/PopupRoulleteSucces";
import { GetDataRoulleteByMagasin } from "../../store/slice/DataApp";

export default function InfoClient() {
  const formRef = useRef();
  const Navigate = useNavigate();
  const [magasinid, setMagasinid] = useState("");
  const [Loading, setLoading] = useState(false);
  const [Progress, setProgress] = useState(0);
  const [codeCommand, setCodeCommand] = useState();
  const magasin = useSelector((state) => state.dataApp.Magasins);
  const clientInfo = useSelector((state) => state.InfoCommand.clientCommand);
  const allImages = useSelector((state) => state.gestionImage.allImages);
  const { type } = useParams();

  const [Roullete, setRoullete] = useState(false);

  const [idCommand, setIdCommand] = useState();
  const [clientType, setClientType] = useState();

  const dispatch = useDispatch();
  useEffect(() => {
    setMagasinid(clientInfo.magasin);
  }, [clientInfo]);

  async function NewCommand(e) {
    e.preventDefault();
    setLoading(true);

    const { nom, telephone, adresse, code } = e.target;
    const formData = new FormData();
    formData.append("nom", nom.value);
    formData.append("telephone", telephone.value);
    formData.append("adresse", adresse?.value || null);
    formData.append("magasin", magasinid);
    formData.append("code", code?.value || null);
    let dataFiles = [];
    Object.keys(allImages).forEach((key, i) => {
      allImages[key].forEach((item, j) => {
        formData.append(`${item.name}${i}${j}`, item.file);
        const dataFile = {
          nomFile: `${item.name}${i}${j}`,
          idproduit: item.idProduit,
          text: item.text ? item.text : null,
          count: item.count ? item.count : 1,
        };
        dataFiles.push(dataFile);
      });
    });
    formData.append("dataFiles", JSON.stringify(dataFiles));
    await axios
      .post(`${api_base}command/Add`, formData, {
        onUploadProgress: (progressEvent) => {
          let percentCompleted = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total
          );
          setProgress(percentCompleted);
        },
      })
      .then((response) => {
        dispatch(GetDataRoulleteByMagasin(magasinid));
        setCodeCommand(response.data.code);

        setIdCommand(response.data.idCommand);
        setClientType(response.data.typeClient);

        setRoullete(true);
        dispatch(VidePanier());
        localStorage.setItem("codeCommand", response.data.code);
      })
      .catch(() => {
        alert("error");
      });
    const data = {
      nom: nom.value,
      telephone: telephone.value,
      adresse: adresse?.value || null,
      magasin: magasinid,
    };
    dispatch(StorageDataClient(data));
    setLoading(false);
  }

  return (
    <>
      <DrawerAppBar />
      <div style={{ background: "#f7f7f7", minHeight: "100vh" }}>
        <Box>
          <Box component="form" onSubmit={NewCommand} ref={formRef}>
            <Typography variant="h3" fontSize={40} textAlign="center">
              info client
            </Typography>
            <Grid
              container
              rowSpacing={4}
              marginTop="4%"
              width="40%"
              marginLeft="30%"
              sx={{
                marginTop: "4%",
                width: "40%",
                marginLeft: "30%",
                "@media (max-width: 700px)": {
                  width: "100%",
                  marginLeft: "0%",
                  padding: "3%",
                },
              }}
            >
              <Grid item xs={12}>
                <Typography variant="h3" fontSize={20} textAlign="center">
                  Je m'inscris et je confirme ma commande
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <TextField
                  placeholder="telephone"
                  name="telephone"
                  label="telephone"
                  fullWidth
                  required
                  defaultValue={clientInfo?.telephone}
                />
              </Grid>

              <Grid item xs={12}>
                <TextField
                  placeholder="Nom"
                  label="Nom"
                  name="nom"
                  fullWidth
                  required
                  defaultValue={clientInfo?.nom}
                />
              </Grid>

              {type === "inStore" ? (
                <Grid item xs={12}>
                  <Autocomplete
                    disablePortal
                    id="magasin"
                    options={magasin}
                    getOptionLabel={(option) => option.Nom || ""}
                    value={
                      magasin.find((option) => option.id === magasinid) || null
                    }
                    onChange={(e, newValue) => {
                      if (newValue) {
                        setMagasinid(newValue.id);
                      } else {
                        setMagasinid(null); // Handle the case where the value is cleared
                      }
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Magasin"
                        required
                        name="magasin"
                      />
                    )}
                  />
                </Grid>
              ) : (
                <Grid item xs={12}>
                  <TextField
                    placeholder="Adresse"
                    label="Adresse"
                    name="adresse"
                    defaultValue={clientInfo?.adresse}
                    fullWidth
                    required
                  />
                </Grid>
              )}

              <Grid item xs={12}>
                <ImportButton
                  disabled={
                    (!allImages.Evenements ||
                      allImages.Evenements.length === 0) &&
                    (!allImages.instax || allImages.instax.length === 0) &&
                    (!allImages.polaroid || allImages.polaroid.length === 0)
                  }
                  variant="contained"
                  type="submit"
                  fullWidth
                >
                  commande
                </ImportButton>
              </Grid>
            </Grid>
          </Box>

          <SuccessWithRouletteDialog
            open={Roullete}
            code={codeCommand}
            clientType={clientType}
            idCommande={idCommand}
            onClose={() => {
              setRoullete(false);
              Navigate("/");
            }}
          />
          <BackLoading open={Loading} Progress={Progress} />
        </Box>
      </div>
    </>
  );
}
